import { Descriptions, Tag } from 'antd'
import type { EnterpriseSummary as Enterprise } from '@super-mega/server/contracts/order'
import { ENTERPRISE_KINDS } from './enterprise-labels.ts'

function relationshipColor(relationship: Enterprise['documentStatus']['relationship']) {
  if (relationship === 'needsReview') {
    return 'orange'
  }
  if (relationship === 'consistent') {
    return 'green'
  }
  return 'default'
}

function identityDescription(enterprise: Enterprise) {
  if (enterprise.identity) {
    return `${enterprise.identity.name} · ${enterprise.identity.maskedIdNumber}`
  }
  if (enterprise.primaryIdentityId) {
    return '已关联（资料受权限保护）'
  }
  return '待补充'
}

export function EnterpriseDocumentStatus({ status }: { status: Enterprise['documentStatus'] }) {
  return (
    <div className="flex flex-wrap gap-1">
      <Tag color={status.company ? 'green' : 'default'}>{status.company ? '企业档案已关联' : '企业档案待补'}</Tag>
      <Tag color={status.businessLicense ? 'green' : 'default'}>
        {status.businessLicense ? '执照原件已提供' : '执照原件待补'}
      </Tag>
      <Tag color={status.identity ? 'green' : 'default'}>{status.identity ? '身份档案已关联' : '身份档案待补'}</Tag>
      <Tag color={status.identityOriginal ? 'green' : 'default'}>
        {status.identityOriginal ? '身份证原件已提供' : '身份证原件待补'}
      </Tag>
      <Tag color={relationshipColor(status.relationship)}>
        {{ unlinked: '法人关系未建立', consistent: '法人关系一致', needsReview: '法人关系待核对' }[status.relationship]}
      </Tag>
    </div>
  )
}

export function EnterpriseSummary({ enterprise }: { enterprise: Enterprise }) {
  return (
    <div className="space-y-3">
      <Descriptions
        size="small"
        column={{ xs: 1, sm: 2 }}
        items={[
          { key: 'name', label: '服务对象', children: enterprise.name },
          { key: 'kind', label: '企业阶段', children: ENTERPRISE_KINDS[enterprise.kind].text },
          { key: 'internal', label: '内部称呼', children: enterprise.displayName },
          { key: 'code', label: '信用代码', children: enterprise.company?.unifiedSocialCreditCode ?? '待补充' },
          { key: 'legal', label: '执照法人姓名', children: enterprise.company?.legalRepresentative ?? '—' },
          {
            key: 'identity',
            label: enterprise.kind === 'prospectiveCompany' ? '拟任法人' : '身份档案',
            children: identityDescription(enterprise)
          }
        ]}
      />
      <div className={'mt-2'}>
        <EnterpriseDocumentStatus status={enterprise.documentStatus} />
      </div>
    </div>
  )
}
